import { render, staticRenderFns } from "./business_form_set.vue?vue&type=template&id=59866bf2&scoped=true&"
import script from "./business_form_set.vue?vue&type=script&lang=js&"
export * from "./business_form_set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59866bf2",
  null
  
)

export default component.exports